/**
 * Reads `?orgFprint=<fprint>` from the current URL. If present, strips the
 * param from the URL via `history.replaceState` so refreshes don't keep
 * forcing the switch, and returns the value. Returns `undefined` when the
 * param is absent.
 *
 * Used by `fetchMemberships` to let external deep links (e.g. the Word
 * add-in's "Use template") choose which org to load on boot, taking
 * precedence over the `orgFprint` cookie.
 */
export function readOrgFprintFromUrl(): string | undefined {
  const params = new URLSearchParams(window.location.search);
  const requested = params.get('orgFprint');
  if (!requested) return undefined;

  params.delete('orgFprint');
  const search = params.toString();
  const newUrl =
    window.location.pathname +
    (search ? `?${search}` : '') +
    window.location.hash;
  window.history.replaceState(null, '', newUrl);

  return requested;
}
